module.exports = __webpack_public_path__ + "img/bianqian.48880724.png";